import sanitizeHtml from "sanitize-html";

const DOMPurify = {
  sanitize: (dirty) =>
    sanitizeHtml(dirty, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(["mark"]),
      allowedAttributes: {
        a: ["href", "target", "rel", "style"],
        mark: [],
      },
      allowedSchemes: ["http", "https", "mailto"],
    }),
};

export default DOMPurify;
